import localeStrings from '../utils/scrumlab-translations';
import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings(localeStrings, {
  pseudo: process.env.REACT_APP_STRING_DEBUG === 'true' ? true : false,
  logsEnabled: false,
});

export default strings;
